import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import UserEditLogLayer from "../../components/Utilities/UserEditLogLayer";
import Breadcrumb from "../../components/Breadcrumb";

const UserEditLogPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="User Edit Log" />
      <UserEditLogLayer />
    </MasterLayout>
  );
};

export default UserEditLogPage;
